module.exports = __webpack_public_path__ + "static/media/header_news_intro.4c2b1a76.png";